const STAGES = [1, 2, 3, 4, 5];
const GENDERS = ['F', 'M'];

function emptyBuckets() {
  return Object.fromEntries(
    STAGES.flatMap((stage) => GENDERS.map((gender) => [`T${stage}${gender}`, 0])),
  );
}

function controlIdentifier(image) {
  const raw = image?.control_group ?? image?.control;
  const text = String(raw ?? '').trim();
  if (!/^\d+$/.test(text)) {
    return null;
  }
  const value = Number(text);
  return Number.isSafeInteger(value) && value > 0 ? value : null;
}

export function catalogCapacity(images = []) {
  const stimulusBuckets = emptyBuckets();
  const stimulusHashes = new Set();
  const controlHashesByGroup = new Map();
  const seenHashes = new Set();

  for (const image of Array.isArray(images) ? images : []) {
    const hash = typeof image?.hash === 'string' ? image.hash.trim() : '';
    if (!hash || seenHashes.has(hash)) {
      continue;
    }
    seenHashes.add(hash);

    const identifier = controlIdentifier(image);
    if (identifier != null) {
      if (!controlHashesByGroup.has(identifier)) {
        controlHashesByGroup.set(identifier, new Set());
      }
      controlHashesByGroup.get(identifier).add(hash);
      continue;
    }

    stimulusHashes.add(hash);
    const stage = Number(image?.tanner);
    const gender = String(image?.gender ?? '').trim().toUpperCase();
    if (STAGES.includes(stage) && GENDERS.includes(gender)) {
      stimulusBuckets[`T${stage}${gender}`] += 1;
    }
  }

  const enabledControlImages = Array.from(controlHashesByGroup.values())
    .reduce((total, hashes) => total + hashes.size, 0);

  return {
    enabledStimuli: stimulusHashes.size,
    stimulusSlidesWorth: Math.min(...Object.values(stimulusBuckets)),
    stimulusBuckets,
    enabledControlImages,
    enabledControlGroups: controlHashesByGroup.size,
    controlSlidesWorth: Array.from(controlHashesByGroup.values())
      .filter((hashes) => hashes.size === 10).length,
  };
}
